import { matches, pickBy } from 'lodash';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const buildMatch = (where: any): any  => {
  return matches(pickBy(where, (v, _k) => v !== undefined));
}
